<template>
  <svg class="svg-icon" aria-hidden="true">
    <use :xlink:href="iconName"></use>
  </svg>
</template>

<script>
  export default {
    props:{
      iconClass:{
        type:String,
        required:true
      }
    },
    data() {
      return {}
    },
    computed:{
      iconName(){
        return `#icon-${this.iconClass}`
      }
    }
  }
</script>

<style lang="less">
  .svg-icon{
    width: 16px;
    height: 16px;
    fill: currentColor;
    overflow: hidden;
    vertical-align: middle;
    position: relative;
    bottom: 1px;
  }
</style>
